import React, { ReactNode } from "react";
import parse, {
  domToReact,
  HTMLReactParserOptions,
  Element,
  DOMNode,
} from "html-react-parser";

export const parseHtml = (htmlContent: string): ReactNode => {
  const options: HTMLReactParserOptions = {
    replace: (domNode) => {
      if (domNode.type === "tag") {
        const element = domNode as Element;

        // Remove <script> tags everywhere (including inside <head>)
        if (element.name === "script") {
          return null;
        }
        // Disable <a> tags
        if (element.name === "a") {
          const { children, attribs = {} } = element;
          const { href, ...otherAttribs } = attribs;

          return (
            <a
              {...otherAttribs}
              onClick={(e) => e.preventDefault()}
              style={{
                color: "gray",
                textDecoration: "none",
                cursor: "not-allowed",
                pointerEvents: "none"
              }}
              title="Link disabled"
              aria-disabled="true"
            >
              {domToReact(children as DOMNode[], options)}
            </a>
          );
        }

        // Disable <button> tags
        if (element.name === "button") {
          const { children, attribs = {} } = element;
          return (
            <button
              {...attribs}
              disabled
              style={{
                backgroundColor: "#ccc",
                cursor: "not-allowed",
              }}
              title="Button disabled"
            >
              {domToReact(children as DOMNode[], options)}
            </button>
          );
        }
      }

      return undefined;
    },
  };

  return parse(htmlContent, options);
};
